import { jiraStatusLabelToId } from "./jiraConstants";

export type SlaState =
  | "onTrack" | "approaching" | "met" | "breachedOpen" | "breachedResolved" | "paused";
export type SlaAction = "RUNNING" | "PAUSED" | "STOPPED";

const RESOLUTION_ACTION_BY_LABEL: Record<string, SlaAction> = {
  "Open": "RUNNING",
  "Under investigation": "RUNNING",
  "Accepted": "RUNNING",
  "In Progress": "RUNNING",
  "Developed": "RUNNING",
  "Released": "PAUSED",
  "Canceled": "PAUSED",
  "Waiting for customer": "PAUSED",
  "Closed": "STOPPED",
};

export const SLA_RESOLUTION_ACTION: Record<string, SlaAction> = Object.fromEntries(
  Object.entries(RESOLUTION_ACTION_BY_LABEL)
    .map(([label, action]) => [jiraStatusLabelToId[label], action] as const)
    .filter(([id]) => Boolean(id)),
);

export function resolutionAction(statusId: string): SlaAction {
  return SLA_RESOLUTION_ACTION[statusId] ?? "RUNNING";
}

